import { ElMessage } from "element-plus";
import axios from "axios";
import router from "@/router";
import { AUTHORIZATION, BEARER } from "@/constant/Const";

//请求拦截器
axios.interceptors.request.use(
  function (config) {
    //请求前做的事
    const token = window.sessionStorage.getItem("token");
    if (token) {
      config.headers[AUTHORIZATION] = `${BEARER}${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (resp) => {
    // 如果是验证码接口，直接返回数据
    if (resp.request?.responseURL?.includes('/api/login/captcha')) {
      return resp.data;
    }
    if (resp.request?.responseURL?.includes('/api/quote/down')) {
      return resp.data;
    }
    
    if (resp.request?.responseURL?.includes('/api/caseBase/down')) {
      return resp.data;
    }
    
    if (resp.data.code == 0 || resp.data.code == 1) {
      resp.data.msg && ElMessage.success({ message: resp.data.msg });
      return resp.data;
    } else if ([504, 404].includes(resp.data.code)) {
      ElMessage.error({ message: "服务找不到..." });
    } else if (resp.data.code == 403) {
      ElMessage.error({ message: "权限不足，请联系管理员！" });
      window.sessionStorage.clear();
      router.replace("/login");
    } else if (resp.data.code == 401) {
      window.sessionStorage.clear();
      ElMessage.error({ message: "尚未登录，请登录！" });
      router.replace("/login");
    } else {
      ElMessage.error({ message: resp.data.msg });
    }
  },
  (error) => {
    if (error.response) {
      const status = error.response.status;
      if ([504, 404].includes(status)) {
        ElMessage.error({ message: "服务找不到..." });
      } else if (status === 403) {
        ElMessage.error({ message: "权限不足，请联系管理员！" });
      } else if (status === 401) {
        window.sessionStorage.clear();
        ElMessage.error({ message: "尚未登录，请登录！" });
        router.replace("/login");
      } else {
        ElMessage.error({ message: error.response.data.msg || "未知错误！" });
      }
    } else {
      ElMessage.error({ message: "网络错误或服务器没有响应！" });
    }
    return Promise.reject(error);
  }
);


let base = "";
export const getRequest = (url, params, responseType = "json") => {
  return axios({
    method: "get",
    url: `${base}${url}`,
    params: params,
    responseType: responseType,
  });
};

export const getRequestRestFul = (url) => {
  return axios({
    method: "get",
    url: `${base}${url}`,
  });
};

export const postRequest = (url, params) => {
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: params,
  });
};
export const deleteRequest = (url, params) => {
  return axios({
    method: "delete",
    url: `${base}${url}`,
    data: params,
  });
};

export const putRequest = (url, params) => {
  return axios({
    method: "put",
    url: `${base}${url}`,
    data: params,
  });
};

export const downPostRequest = (url, params) => {
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: params,
    responseType: "blob",
    // headers: {
    //     "Content-Type": "application/json;charset=UTF-8",
    // },
  });
};
export const downGetRequest = (url, params) => {
  return axios({
    method: "get",
    url: `${base}${url}`,
    params: params,
    responseType: "blob",
    // headers: {
    //     "Content-Type": "application/json;charset=UTF-8",
    // },
  });
};
